import { GeneralSetting } from '@apis/index'
import Button from '@components/button'
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  ActionContainer,
  BannerImage,
  BannerImageContainer,
  BannerImageWrapper,
  DeleteBannerSection,
  EmptyState,
  SectionTitle,
} from './style'

const DeleteBanner = ({ toggleBannerType }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState(null)
  const [selectedBannerId, setSelectedBannerId] = useState(null)
  const [localData, setLocalData] = useState([])

  const state = toggleBannerType === 'Header' ? 'topBanner' : 'bottomBanner'

  const fetchTopBanner = async () => {
    await GeneralSetting.getByGroup('topBanner', 'banner-list', 'Header')
      .then(() => {})
      .catch(() => {})
  }

  const { data: topBanner } = useSelector((state: any) => state.topBanner)

  const fetchBottomBanner = async () => {
    await GeneralSetting.getByGroup('bottomBanner', 'banner-list', 'Footer')
      .then(() => {})
      .catch(() => {})
  }

  const { data: bottomBanner } = useSelector((state: any) => state.bottomBanner)

  useEffect(() => {
    if (state === 'topBanner' && Array.isArray(topBanner)) {
      setLocalData(topBanner)
    } else if (state === 'bottomBanner' && Array.isArray(bottomBanner)) {
      setLocalData(bottomBanner)
    }
  }, [state, topBanner, bottomBanner])

  useEffect(() => {
    if (state === 'topBanner') {
      fetchTopBanner()
    } else {
      fetchBottomBanner()
    }
  }, [state])

  useEffect(() => {
    setSelectedIndex(null)
    setSelectedBannerId(null)
  }, [toggleBannerType])

  const handleItemClick = (bannerId, index) => {
    if (selectedIndex === index) {
      setSelectedIndex(null)
      setSelectedBannerId(null)
    } else {
      setSelectedIndex(index)
      setSelectedBannerId(bannerId)
    }
  }

  const confirmDelete = async () => {
    setLoading(true)

    await GeneralSetting.remove(state, selectedBannerId)
      .then(() => {
        const newData = [...localData]
        newData.splice(selectedIndex, 1)
        setLocalData(newData)

        if (state === 'topBanner') {
          dispatch({ type: 'FETCH_TOP_BANNER_REQUEST' })
          fetchTopBanner()
        } else {
          dispatch({ type: 'FETCH_BOTTOM_BANNER_REQUEST' })
          fetchBottomBanner()
        }

        setSelectedBannerId(null)
        setSelectedIndex(null)
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false)
      })
  }

  const bannerImages = localData.map((item: any) => ({
    id: item.id,
    url: `${process.env.BUCKET_URL}/${item.file}`,
  }))

  //   useEffect(() => {
  //     fetchTopBanner()
  //     fetchBottomBanner()
  //   }, [topBanner, bottomBanner, bannerImages])

  return (
    <DeleteBannerSection>
      <SectionTitle>Manage {toggleBannerType} Banners</SectionTitle>

      {bannerImages.length > 0 ? (
        <>
          <BannerImageContainer>
            {bannerImages.map((image, index) => (
              <BannerImageWrapper
                key={index}
                isSelected={selectedIndex === index}
                onClick={() => handleItemClick(image.id, index)}
              >
                <BannerImage
                  src={image.url}
                  alt={`${toggleBannerType} banner ${index + 1}`}
                />
              </BannerImageWrapper>
            ))}
          </BannerImageContainer>
          {selectedIndex !== null && (
            <ActionContainer>
              <Button
                title="Delete Selected Banner"
                onClick={confirmDelete}
                styleButton="background-color: red"
                loading={loading}
              />
            </ActionContainer>
          )}
        </>
      ) : (
        <EmptyState>No {toggleBannerType} banners found.</EmptyState>
      )}
    </DeleteBannerSection>
  )
}

export default DeleteBanner
